export enum SidebarTabIds {
	IN_WALLET_TAB = 0,
	IN_REWARDS_TAB = 1,
	IN_PURCHASES_TAB = 2,
	IN_STATS_TAB = 3,
}
